import { EmbeddedSandbox } from '@optools/services/operator-gateway/sandbox';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sandbox')({
  beforeLoad: () => {
    if (process.env.NODE_ENV !== 'development' || APOLLO_SANDBOX === 'disabled') {
      throw redirect({ to: '/' });
    }
  },
  component: EmbeddedSandbox,
});
